import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { FlexGrid, CellType, CellRange, GridPanel, Row, FormatItemEventArgs, MergeManager } from '@grapecity/wijmo.grid';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { PlessViewUtils } from 'src/app/shared/utils/pless-view-utils.service';
import { CanDeactivateType } from 'src/app/shared/utils/leave-confirm.guard';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { TextInputComponent } from 'src/app/commons/kymw02/text-input/text-input/text-input.component';
import { ClassCodeComboBoxComponent } from 'src/app/commons/kymw02/combo-box/class-code-combo-box/class-code-combo-box.component';

import { KYMW9009Model } from './kymw9009.model';
import { GetUserClassManagementModel } from './vo/get-user-class-management.model';
import { GetOktaUserNameModel } from './vo/get-okta-user-name.model';
import { GetOktaInfomationModel } from './vo/get-okta-infomation.model';
import { UserClassManagementModel } from './vo/user-class-management.model';

import { GetUserClassManagementListService } from './api-services/get-user-class-management-list.service';
import { GetOktaInfomationListService } from './api-services/get-okta-infomation-list.service';
import { UpdateUserClassManagementService } from './api-services/update-user-class-management.service';
import { DeleteUserClassManagementService } from './api-services/delete-user-class-management.service';
import { GetOktaUserNameService } from './api-services/get-okta-user-name.service';


/**
 * ユーザ階層管理画面を管理するクラス
 *
 * @export KYMW9009Component
 * @class KYMW9009Component
 */
@Component({
  selector: 'app-kymw9009',
  templateUrl: 'kymw9009.component.html',
  styleUrls: ['kymw9009.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW9009Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('cmb_ClassCode', { static: true }) cmb_ClassCode: ClassCodeComboBoxComponent;
  @ViewChild('btn_Display', { static: true }) btn_Display: ElementRef;
  @ViewChild('dtg_UserClassList', { static: true }) dtg_UserClassList: FlexGrid;
  @ViewChild('btn_Update', { static: true }) btn_Update: ElementRef;
  @ViewChild('btn_Delete', { static: true }) btn_Delete: ElementRef;

  @ViewChild('txt_UserNmKanji', { static: true }) txt_UserNmKanji: TextInputComponent;
  @ViewChild('txt_UserDeptNm', { static: true }) txt_UserDeptNm: TextInputComponent;
  @ViewChild('btn_Search', { static: true }) btn_Search: ElementRef;
  @ViewChild('dtg_OktInfoList', { static: true }) dtg_OktInfoList: FlexGrid;

  /**
   * KYMW9009Modelオブジェクト
   */
  public kymw9009Model: KYMW9009Model = new KYMW9009Model();

  /** 編集済みかをチェックするフラグ */
  public editFlag: boolean = <boolean>false;

  /** 権限「1」は閲覧モード「2」フルコントロール */
  public funcPermission: string = <string>'2';

  /** ユーザ階層管理一覧の背景色設定変数 */
  private BACK_WHITE = 'backgroud-color-white';
  private BACK_GRAY = 'backgroud-color-gray';

  /**
   *Creates an instance of KYMW9009Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {GetUserClassManagementListService} getUserClassManagementListService
   * @param {GetOktaInfomationListService} getOktaInfomationListService
   * @param {UpdateUserClassManagementService} updateUserClassManagementService
   * @param {DeleteUserClassManagementService} deleteUserClassManagementService
   * @param {GetOktaUserNameService} getOktaUserNameService
   * @memberof KYMW9009Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getUserClassManagementListService: GetUserClassManagementListService,
    private getOktaInfomationListService: GetOktaInfomationListService,
    private updateUserClassManagementService: UpdateUserClassManagementService,
    private deleteUserClassManagementService: DeleteUserClassManagementService,
    private getOktaUserNameService: GetOktaUserNameService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   * ※部門情報のコンボボックス生成は、共通部品のClassCodeComboBoxComponentに任せる
   * @returns {void}
   * @memberof KYMW9009Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW9009';
    this.kymw9009Model.kymw9009Component = this;

    // ユーザ階層管理グリッドの部門ごとの背景色設定
    this.dtg_UserClassList.loadedRows.addHandler(() => {
      let rowNo = 0;
      for (const row of this.dtg_UserClassList.rows) {
        if (row.index === 0) {
          row.cssClass = this.BACK_WHITE;
        }
        else {
          if (this.dtg_UserClassList.rows[row.index - 1].dataItem.ClassCode !== row.dataItem.ClassCode) {
            rowNo++;
          }
          if (rowNo % 2 === 0) {
            row.cssClass = this.BACK_WHITE;
          } else {
            row.cssClass = this.BACK_GRAY;
          }
        }
      }
    });

    // Okta情報グリッド行の選択解除
    this.dtg_OktInfoList.itemsSourceChanged.addHandler(() => {
      this.dtg_OktInfoList.select(-1, -1);
    });

    // 権限制御取得（0：使用不可、1：閲覧のみ、2：フルコントロール可能（帳票出力、更新））
    this.funcPermission = super.getFuncPermission();
  }

  /**
   * ディアクティベート処理
   * @returns {CanDeactivateType}
   * @memberof KYMW9009Component
   */
  public canDeactivate(): CanDeactivateType {
    const result = new Subject<boolean>();

    // 「閲覧モードではない」かつ「内容が変更されている」時は確認メッセージを表示
    if (!this.isDispOnlyMode() && this.editFlag) {
      this.dialogService.openAlertGetMessage(
        'Q0110', [],
        (closeDetail: any): void => {
          if (closeDetail === PlessAlert.Yes) {
            result.next(true);
          } else {
            result.next(false);
          }
        });
      return result;
    } else {
      return true;
    }
  }

  /**
   * ユーザ階層管理一覧グリッドの初期化処理
   *
   * @param {FlexGrid} grid
   * @memberof KYMW9009Component
   */
  public onDtgUserClassListInitialized(grid: FlexGrid) {

    // ユーザ階層管理グリッドのセルマージ
    grid.mergeManager = new UserClassListMergeManager();

    // ヘッダ行のマージ構成の準備（マージ処理自体はUserClassListMergeManager）
    // ヘッダに行挿入
    const extraRow = new Row();
    extraRow.allowMerging = true;
    const columnHeadersPanel = grid.columnHeaders;
    columnHeadersPanel.rows.splice(0, 0, extraRow);

    // 部門（行結合）
    const col = grid.getColumn('ClassName');
    col.allowMerging = true;
    columnHeadersPanel.setCellData(0, col.index, col.header);
    // 部門行結合の水平位置調整
    grid.formatItem.addHandler((grid: FlexGrid, e: FormatItemEventArgs) => {
      if (e.panel == grid.columnHeaders && e.range.rowSpan > 1) {
          e.cell.innerHTML = '<div class="v-center">' + e.cell.innerHTML + '</div>';
      }
    });

    // グループ長、担当者、代行者（列結合）
    columnHeadersPanel.setCellData(0, 1, KYMW9009Model.CLASS_GROUP_NAME);
    columnHeadersPanel.setCellData(0, 5, KYMW9009Model.CLASS_STAFF_NAME);
    columnHeadersPanel.setCellData(0, 9, KYMW9009Model.CLASS_AGENT_NAME);
    
    // ユーザ階層管理：初期検索
    this.eventDisplay_CLICKHandler();
  }

  /**
   * ボタン「表示」クリックイベントリスナ
   *
   * @returns {void}
   * @memberof KYMW9009Component
   */
  public eventDisplay_CLICKHandler(): void {

    // 部門コンボボックスの選択値からVO設定
    const vo: GetUserClassManagementModel = new GetUserClassManagementModel();
    vo.ClassCode = this.cmb_ClassCode.selectedClassCode

    // 未更新チェック処理
    // 「閲覧モードではない」かつ「内容が変更されている」時は確認メッセージを表示
    if (!this.isDispOnlyMode() && this.editFlag) {
      this.dialogService.openAlertGetMessage(
        'Q0110', [],
        (closeDetail: any): void => {
          if (closeDetail === PlessAlert.Yes) {
            this.displayUserClassManagementList(vo);
          }
        }
      );
    } else {
      this.displayUserClassManagementList(vo);
    }
  }

  /**
   * ユーザ階層管理一覧の表示処理
   *
   * @returns {void}
   * @memberof KYMW9009Component
   */
  public displayUserClassManagementList(vo: GetUserClassManagementModel): void {
    // ユーザ階層管理取得API
    this.getUserClassManagementListService.execute(this.kymw9009Model, vo);
  }

  /**
   * ボタン「追加」クリックイベントリスナ
   *
   * @param {number} selectedIndex
   * @param {string} target
   * @returns {void}
   * @memberof KYMW9009Component
   */
  public eventUserAdd_CLICKHandler(selectedIndex: number, target: string): void {

    if (selectedIndex >= 0) {
      const selectedItem: UserClassManagementModel = this.dtg_UserClassList.itemsSource[selectedIndex];
      // 「追加」をクリックしたのが担当者・代行者の場合、チェック選択が上位階層とずれるため参照位置を修正
      if (target !== KYMW9009Model.CLASS_GROUP) {
        this.syncUserCheckFromParents(selectedItem, selectedIndex, target);
      }
      // モデルに追加して、グリッド更新
      this.kymw9009Model.addUserClassLine(selectedItem, selectedIndex, target);
      this.dtg_UserClassList.collectionView.refresh();
      this.setEditFlag();
    }
  }

  /**
   * 入力欄「ユーザID」フォーカスアウトイベントリスナ
   *
   * @param {number} selectedIndex
   * @param {string} target
   * @returns {void}
   * @memberof KYMW9009Component
   */
  public eventUserId_FOCUSOUTHandler(selectedIndex: number, target: string): void {

    if (selectedIndex >= 0) {
      const selectedItem: UserClassManagementModel = this.dtg_UserClassList.itemsSource[selectedIndex];

      // 対象項目を決定
      // 入力値が変更されていない場合
      if (selectedItem[target + 'UserId'] === selectedItem[target + "UserIdBeforeInput"]) {
        return;
      }

      // 入力されたユーザIDから、ユーザ名を取得する（グループ長、担当者、代行者）
      const userId = selectedItem[target + 'UserId'];
      if (!PlessViewUtils.isEmpty(userId)) {    
  
        // VO設定
        const vo: GetOktaUserNameModel = new GetOktaUserNameModel();
        vo.UserId = userId;
        vo.TargetIndex = selectedIndex;
        vo.TargetItemName = target;

        // Oktaユーザ名取得API
        this.getOktaUserNameService.execute(this.kymw9009Model, vo);

      // 入力ユーザIDが空の場合はユーザ名を消す
      } else {
        selectedItem[target + "UserIdBeforeInput"] = userId;
        selectedItem[target + "UserName"] = '';
        selectedItem[target + "UserError"] = false;
        selectedItem[target + "UserCheck"] = false;
        this.kymw9009Model.reflectSameLevel(selectedItem, target);
        this.kymw9009Model.refreshUserClass();
      }
      this.setEditFlag();
    }
  }

  /**
   * ボタン「更新」クリックイベントリスナ
   *
   * @returns {void}
   * @memberof KYMW9009Component
   */
  public eventUpdate_CLICKHandler(): void {

    // エラー箇所をクリア
    this.kymw9009Model.resetInputError();

    // 更新対象のユーザ階層管理一覧を抽出
    const updateList: Array<UserClassManagementModel> = this.choiceCheckedList();

    // 入力チェック
    if (!this.inputCheckUpdateUserClass(updateList)) {
      this.kymw9009Model.refreshUserClass();
      return;
    }

    this.dialogService.openAlertGetMessage(
      'Q0108', ['ユーザ階層管理'],
      (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          // ユーザ階層管理更新API
          this.updateUserClassManagementService.execute(this.kymw9009Model, updateList);
        }
      }
    );
  }

  /**
   * ボタン「削除」クリックイベントリスナ
   *
   * @returns {void}
   * @memberof KYMW9009Component
   */
  public eventDelete_CLICKHandler(): void {

    // エラー箇所をクリア
    this.kymw9009Model.resetInputError();

    // 更新対象のユーザ階層管理一覧を抽出
    const tempDeleteList: Array<UserClassManagementModel> = this.choiceCheckedList();

    // 入力チェック
    if (!this.inputCheckDeleteUserClass(tempDeleteList)) {
      this.kymw9009Model.refreshUserClass();
      return;
    }

    // 追加行を除外する
    const deleteList: Array<UserClassManagementModel> = new Array<UserClassManagementModel>();
    tempDeleteList.forEach((elm) => {
      if (!elm.Added) deleteList.push(elm);
    });
    // 除外後にリストがなかれば終了（画面再描画）
    if (deleteList.length === 0) {
      this.kymw9009Model.updateUserClassDeleted();
      return;
    }

    // 確認メッセージを表示
    let msgId = 'Q0106';
    if (this.existChildUser(deleteList)) {
      msgId = 'Q0165';
    }
    this.dialogService.openAlertGetMessage(
      msgId, ['ユーザ階層管理'],
      (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {

          // ユーザ階層管理削除API
          this.deleteUserClassManagementService.execute(this.kymw9009Model, deleteList);
        }
      }
    );
  }

  /**
   * ボタン「検索」クリックイベントリスナ
   *
   * @returns {void}
   * @memberof KYMW9009Component
   */
  public eventSearch_CLICKHandler(): void {

    // 検索条件入力からVO設定
    const vo: GetOktaInfomationModel = new GetOktaInfomationModel();
    vo.UserNmKanji = this.txt_UserNmKanji.text;
    vo.UserDeptNm = this.txt_UserDeptNm.text;

    // 入力チェック
    if (!this.inputCheckGetOktaInfo(vo)) {
      return;
    }

    // Okta情報一覧取得API
    this.getOktaInfomationListService.execute(this.kymw9009Model, vo);
  }


  /**
   * チェック付きのユーザ階層管理一覧を抽出する
   *
   * @return {Array<UserClassManagementModel>} 抽出されたユーザ階層管理一覧
   * @memberof KYMW9009Component
   */
  private choiceCheckedList(): Array<UserClassManagementModel> {
    const targetList: Array<UserClassManagementModel> = new Array<UserClassManagementModel>();
    this.dtg_UserClassList.itemsSource.forEach(elm => {
      if (!elm.OnlyOperation) { // 操作専用行を除く
        if (elm.GroupUserCheck || elm.StaffUserCheck || elm.AgentUserCheck) { // チェックが付いている
          targetList.push(elm);
        }
      }
    });
    return targetList;
  }

  /**
   * Okta情報一覧取得の入力チェック
   *
   * @param {GetOktaInfomationModel} vo 検索条件VO
   * @returns {boolean} true:OK false:NG
   * @memberof KYMW9009Component
   */
  private inputCheckGetOktaInfo(vo: GetOktaInfomationModel): boolean {
    return true;
  }

  /**
   * ユーザ階層管理更新の入力チェック
   *
   * @param {Array<UserClassManagementModel>} targetList チェック対象更新VOリスト
   * @returns {boolean} true:OK false:NG
   * @memberof KYMW9009Component
   */
  private inputCheckUpdateUserClass(targetList: Array<UserClassManagementModel>): boolean {

    // 未選択のチェック
    if (!this.checkUnSelected(targetList)) {
      return false;
    }

    for (let i = Number(0); i < targetList.length; i++) {
      const model = targetList[i];

      // ユーザID必須チェック、ユーザ存在チェック
      if (model.GroupUserCheck) {
        if (PlessViewUtilsSub.isEmpty(model.GroupUserId)) {
          this.showAlertDialog('E0110', [KYMW9009Model.CLASS_GROUP_NAME + 'ユーザID']);
          model.GroupUserError = true;
          return false;
        } else {
          // ユーザIDあるのにユーザ名なし 
          if (PlessViewUtilsSub.isEmpty(model.GroupUserName)) {
            this.showAlertDialog(
              'E0580', [model.ClassName, KYMW9009Model.CLASS_GROUP_NAME, model.GroupUserId]);
            model.GroupUserError = true;
            return false;
          }
        }
      }
      if (model.StaffUserCheck) {
        if (PlessViewUtilsSub.isEmpty(model.StaffUserId)) {
          this.showAlertDialog('E0110', [KYMW9009Model.CLASS_STAFF_NAME + 'ユーザID']);
          model.StaffUserError = true;
          return false;
        } else {
          // ユーザIDあるのにユーザ名なし
          if (PlessViewUtilsSub.isEmpty(model.StaffUserName)) {
            this.showAlertDialog(
              'E0580', [model.ClassName, KYMW9009Model.CLASS_STAFF_NAME, model.StaffUserId]);
            model.StaffUserError = true;
            return false;
          }
        }
      }
      if (model.AgentUserCheck) {
        if (PlessViewUtilsSub.isEmpty(model.AgentUserId)) {
          this.showAlertDialog('E0110', [KYMW9009Model.CLASS_AGENT_NAME + 'ユーザID']);
          model.AgentUserError = true;
          return false;
        } else {
          // ユーザIDあるのにユーザ名なし
          if (PlessViewUtilsSub.isEmpty(model.AgentUserName)) {
            this.showAlertDialog(
              'E0580', [model.ClassName, KYMW9009Model.CLASS_AGENT_NAME, model.AgentUserId]);
            model.AgentUserError = true;
            return false;
          }
        }
      }

      // 同一階層ユーザ重複チェック
      if (!this.checkDuplicationLevel(model)) {
        return false;
      }
      // 上位階層ユーザ登録チェック
      if (!this.checkExistUpperLevel(model)) {
        return false;
      }
    }

    return true;
  }

  /**
   * ユーザ階層管理削除の入力チェック
   *
   * @param {Array<UserClassManagementModel>} targetList チェック対象更新VOリスト
   * @returns {boolean} true:OK false:NG
   * @memberof KYMW9009Component
   */
  private inputCheckDeleteUserClass(targetList: Array<UserClassManagementModel>): boolean {

    // 未選択のチェック
    if (!this.checkUnSelected(targetList)) {
      return false;
    }
    return true;
  }

  /**
   * 未選択チェック
   *
   * @param {Array<UserClassManagementModel>} targetList チェック対象更新VOリスト
   * @returns {boolean} true:OK false:NG
   * @memberof KYMW9009Component
   */
  private checkUnSelected(targetList: Array<UserClassManagementModel>): boolean {
    if (targetList.length === 0) {
      this.showAlertDialog('E0103', ['ユーザ階層管理']);
      return false;
    }
    return true;
  }

  /**
   * 同一階層の重複チェック
   *
   * @param {Array<UserClassManagementModel>} checkModel チェック対象更新VO
   * @returns {boolean} true:OK false:NG
   * @memberof KYMW9009Component
   */
  private checkDuplicationLevel(checkModel: UserClassManagementModel): boolean {

    // ユーザ階層管理グリッドの全行をループして比較を行う
    for (let i = Number(0); i < this.dtg_UserClassList.itemsSource.length; i++) {
      const elm = this.dtg_UserClassList.itemsSource[i];

      if (!elm.OnlyOperation) { // 操作行は除く

        // 同階層の重複チェック　※可読性とコードチェックのため、敢えて入れ子階層に記載する

        if (checkModel.GroupUserCheck) {                                // グループ長にチェックがある
          if (checkModel.ClassCode === elm.ClassCode) {                 // 同じ部門である
            if (checkModel.GroupOriginSetId !== elm.GroupOriginSetId) { // 部門ごとグループ長の固まりを表す識別子が異なる
              if (checkModel.GroupUserId === elm.GroupUserId) {         // グループ長ユーザIDが同じだとエラー
                this.showAlertDialog(
                  'E0570', [checkModel.ClassName, KYMW9009Model.CLASS_GROUP_NAME, checkModel.GroupUserId]);
                checkModel.GroupUserError = true;
                return false;
              }
            }
          }
        }
        if (checkModel.StaffUserCheck) {                                  // 担当者にチェックがある
          if (checkModel.ClassCode === elm.ClassCode) {                   // 同じ部門である
            if (checkModel.GroupUserId === elm.GroupUserId) {             // 同じグループ長である
              if (checkModel.StaffOriginSetId !== elm.StaffOriginSetId) { // グループ長ごと担当者の固まりを表す識別子が異なる
                if (checkModel.StaffUserId === elm.StaffUserId) {         // 担当者ユーザIDが同じだとエラー
                  this.showAlertDialog(
                    'E0570', [checkModel.ClassName, KYMW9009Model.CLASS_STAFF_NAME, checkModel.StaffUserId]);
                  checkModel.StaffUserError = true;
                  return false;
                }
              }
            }
          }
        }
        if (checkModel.AgentUserCheck) {                                    // 代行者にチェックがある
          if (checkModel.ClassCode === elm.ClassCode) {                     // 同じ部門である
            if (checkModel.GroupUserId === elm.GroupUserId) {               // 同じグループ長である
              if (checkModel.StaffUserId === elm.StaffUserId) {             // 同じ担当者である
                if (checkModel.AgentOriginSetId !== elm.AgentOriginSetId) { // 担当者ごと代行者の固まりを表す識別子が異なる
                  if (checkModel.AgentUserId === elm.AgentUserId) {         // 代行者ユーザIDが同じだとエラー
                    this.showAlertDialog(
                      'E0570', [checkModel.ClassName, KYMW9009Model.CLASS_AGENT_NAME, checkModel.AgentUserId]);
                    checkModel.AgentUserError = true;
                    return false;
                  }
                }
              }
            }
          }
        }
      }
    }
    return true;
  }

  /**
   * 上位階層の登録チェック
   *
   * @param {Array<UserClassManagementModel>} checkModel チェック対象更新VO
   * @returns {boolean} true:OK false:NG
   * @memberof KYMW9009Component
   */
  private checkExistUpperLevel(checkModel: UserClassManagementModel): boolean {

    if (checkModel.StaffUserCheck) {  // 担当者にチェックがある
      // グループ長の変更前ユーザIDが空(つまり新規追加)で、選択チェックがついてない場合エラー
      if (PlessViewUtilsSub.isEmpty(checkModel.GroupUserIdOrigin) && !checkModel.GroupUserCheck) {
        this.showAlertDialog(
          'E0581', [checkModel.ClassName, KYMW9009Model.CLASS_STAFF_NAME, checkModel.StaffUserId]);
        checkModel.StaffUserError = true;
        return false;
      }
    }
    if (checkModel.AgentUserCheck) {  // 代行者にチェックがある
      // グループ長の変更前ユーザIDが空(つまり新規追加)で、選択チェックがついてない場合 AND
      // 担当者の変更前ユーザIDが空(つまり新規追加)で、選択チェックがついてない場合エラー
      if ((PlessViewUtilsSub.isEmpty(checkModel.GroupUserIdOrigin) && !checkModel.GroupUserCheck)
      ||  (PlessViewUtilsSub.isEmpty(checkModel.StaffUserIdOrigin) && !checkModel.StaffUserCheck)) {
        this.showAlertDialog(
          'E0581', [checkModel.ClassName, KYMW9009Model.CLASS_AGENT_NAME, checkModel.AgentUserId]);
        checkModel.AgentUserError = true;
        return false;
      }
    }

    return true;
  }

  /**
   * アラートダイアログ表示
   *
   * @param {string} msgId メッセージID
   * @param {Array<string>} args 置換文字列
   * @returns {void}
   * @memberof KYMW9009Component
   */
  public showAlertDialog(msgId: string, args: Array<string>): void {
    this.dialogService.openAlertGetMessage(msgId, args);
  }

  /**
   * 紐づくユーザの存在チェック
   *
   * @param {Array<UserClassManagementModel>} targetList チェック対象更新VOリスト
   * @returns {boolean} true:存在する false:存在しない
   * @memberof KYMW9009Component
   */
  private existChildUser(targetList: Array<UserClassManagementModel>): boolean {

    for (let i = 0; i < targetList.length; i++) {
      const model = targetList[i];

      // グループ長の場合、紐づくか担当者が存在するか
      if (model.GroupUserCheck) {
        if (!PlessViewUtilsSub.isEmpty(model.StaffUserIdBeforeInput)) {
          return true;
        }
      }
      // 担当者の場合、紐づくか代行者が存在するか
      if (model.StaffUserCheck) {
        if (!PlessViewUtilsSub.isEmpty(model.AgentUserIdBeforeInput)) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * 閲覧モードであるか
   * @returns 閲覧モードであればtrue
   * @memberof KYMW9009Component
   */
  public isDispOnlyMode(): boolean {
    return this.funcPermission === '1';
  }

  /**
   * 編集フラグをたてる
   * @returns {void}
   * @memberof KYMW9009Component
   */
  public setEditFlag(): void {
    this.editFlag = true;
  }

  /**
   * 編集フラグをクリアする
   * @returns {void}
   * @memberof KYMW9009Component
   */
  public clearEditFlag(): void {
    this.editFlag = false;
  }

  /**
   * ユーザ階層管理一覧の列数から階層識別子を取得する
   *
   * @param {number} c 列インデクス
   * @returns {string} 階層識別子
   * @memberof KYMW9009Component
   */
  public static getItemNameByCol(c: number): string {
    if (c == 0) {
      return 'ClassCode';
    } else if (c >= 1 && c <= 4) {
      return 'GroupOriginSetId';
    } else if (c >= 5 && c <= 8) {
      return 'StaffOriginSetId';
    } else if (c >= 9 && c <= 12) {
      return 'AgentOriginSetId';
    } else {
      return '';
    }
  }

  /**
   * 担当者・代行者のチェック選択が上位階層とずれるため参照位置を修正
   * 
   * @param {UserClassManagementModel} selectedItem
   * @param {UserClassManagementModel} selectedIndex
   * @param {UserClassManagementModel} target
   * @returns {void}
   * @memberof KYMW9009Component
   */
  public syncUserCheckFromParents(selectedItem :UserClassManagementModel, selectedIndex: number, target: string): void {
    // 紐づいている上位階層が新規追加の場合のみ処理を行う
    // 担当者追加
    if (target === KYMW9009Model.CLASS_STAFF && PlessViewUtilsSub.isEmpty(selectedItem.GroupUserIdOrigin)) {
      for(let i = selectedIndex; i >= 0; i--) {
        const row = this.dtg_UserClassList.itemsSource[i];
        if (row.GroupUserCheck){
          selectedItem.GroupUserCheck = row.GroupUserCheck;
          break;
        }
      }
    // 代行者追加
    // 代行者の場合、担当者とグループ長両方を確認
    } else if (target === KYMW9009Model.CLASS_AGENT && PlessViewUtilsSub.isEmpty(selectedItem.StaffUserIdOrigin)) {
      let group = false;
      let staff = false;
      for(let i = selectedIndex; i >= 0; i--) {
        const row = this.dtg_UserClassList.itemsSource[i];
        // 担当者
        if (!staff && row.StaffUserCheck){
          selectedItem.StaffUserCheck = row.StaffUserCheck;
          staff = true;
        }
        // グループ長
        if (!group && row.GroupUserCheck){
          selectedItem.GroupUserCheck = row.GroupUserCheck;
          group = true;
        }
        if (group && staff) {
          break;
        }
      }
    }
  }
}


/**
 * ユーザ階層管理一覧FlexGridのマージマネージャクラス
 *
 * @class UserClassListMergeManager
 * @extends MergeManager
 * @memberof KYMW9009Component
 */
class UserClassListMergeManager extends MergeManager {

  /**
   * ユーザ階層管理一覧FlexGridのマージマネージャクラス
   *
   * @param {GridPanel} p グリッドパネル
   * @param {number} r 行インデックス
   * @param {number} c 列インデックス
   * @param {boolean} clip optionnal
   * @returns {CellRange} マージ範囲
   * @memberof UserClassListMergeManager
   */
  getMergedRange(p: GridPanel, r: number, c: number, clip: boolean = true): CellRange {
    // 列ヘッダ
    if (p.cellType === CellType.ColumnHeader || p.cellType === CellType.TopLeft) {
      if ((r == 0 || r == 1) && c == 0) {
        return new CellRange(0, 0, 1, 0);  // ヘッダ：部門（行結合）
      }
      if (r == 0 && c >= 1 && c <= 4) {
        return new CellRange(0, 1, 0, 4);  // ヘッダ：グループ長（列結合）
      }
      if (r == 0 && c >= 5 && c <= 8) {
        return new CellRange(0, 5, 0, 8);    // ヘッダ：担当者（列結合）
      }
      if (r == 0 && c >= 9 && c <= 12) {
        return new CellRange(0, 9, 0, 12);   // ヘッダ：代行者（列結合）
      }
    // 列ヘッダ以外：行方向に同じ値が続くセルを結合
    } else if (p.cellType === CellType.Cell) {

      let rng = new CellRange(r, c);
      const pcol = c > 0 ? c - 1 : c;
      const val = this.getIdentifierData(p, r, c);
      const pval = this.getIdentifierData(p, r, pcol);
      // expand up
      while (rng.row > 0 &&
        this.getIdentifierData(p, rng.row - 1, c) == val &&
        this.getIdentifierData(p, rng.row - 1, pcol) == pval
      ) {
          rng.row--;
      }
      // expand down
      while (rng.row2 < p.rows.length - 1 &&
        this.getIdentifierData(p, rng.row2 + 1, c) == val &&
        this.getIdentifierData(p, rng.row2 + 1, pcol) == pval
      ) {
          rng.row2++;
      }
      // 単セル(結合なし)
      if (rng.isSingleCell) {
          rng = null;
      }
      return rng;
    }
  }
  private getIdentifierData(p: GridPanel, r: number, c: number) {
    // 対象行のバインドされたデータアイテム
    const item = p.rows[r].dataItem;
    const data = item[KYMW9009Component.getItemNameByCol(c)];
    // 追加行と操作行はマージしないためにダミーの識別子（dummy + 行インデックス + 列インデックス）を設定
    return (PlessViewUtilsSub.isEmpty(data)) ? 'dummy' + r + c : data;
  }
}